import type { ResolveResponse } from "./types";

export interface ThreadTextLabels {
  mainPost: string;
  replies: string;
  quotedPost: string;
  partialReplies: string;
}

export function buildThreadText(result: ResolveResponse, labels: ThreadTextLabels): string {
  const lines = [
    labels.mainPost,
    `@${result.author.username}`,
    result.publishedAt || "",
    result.source.canonicalUrl,
    "",
    result.text
  ];

  if (result.quotedPost) {
    lines.push("", labels.quotedPost, `@${result.quotedPost.author.username}`, "", result.quotedPost.text);
  }

  if (result.replies.length > 0 || result.replySummary.expectedDirectCount > 0) {
    lines.push("", "---", `${labels.replies} (${result.replySummary.loadedTotalCount})`);
    if (!result.replySummary.complete) {
      lines.push(labels.partialReplies
        .replace("{loaded}", String(result.replySummary.loadedDirectCount))
        .replace("{expected}", String(result.replySummary.expectedDirectCount)));
    }
    for (const reply of result.replies) {
      const indent = "  ".repeat(Math.max(0, reply.depth - 1));
      lines.push(
        "",
        `${indent}↳ @${reply.author.username}`,
        reply.publishedAt ? `${indent}${reply.publishedAt}` : "",
        `${indent}${reply.permalink}`,
        "",
        ...reply.text.split("\n").map((line) => `${indent}${line}`)
      );
    }
  }

  return lines.filter((line, index, values) => line !== "" || values[index - 1] !== "").join("\n").trim() + "\n";
}
